// Mint-Booking-Msg: mở thư info@ theo Message-ID (MSGID · MX · MTD trong script board Mint-Booking). Dữ liệu mẫu, chưa nối hộp thư thật.
import { MAILS, type Mail } from '../booking/mail';

export const DEFAULT_MESSAGE_ID = '<BC-SGNGCQ104300.0912@••••.com>';

/** Message-ID (RFC 5322) theo thứ tự MAILS. */
export const MSG_IDS: readonly string[] = [
  '<AP2611.W45.0920@••••.vn>', '<BC-SGNGCQ104300.0912@••••.com>', '<WHL-DLY-W028-0905@••••.com>', '<GRI-0111-ME.0847@••••.com>',
  '<VGM-YMLU4410237.0831@••••.com>', '<RF-WHSU8821004.0820@••••.com>', '<DBL-VN01175201.0802@••••.vn>', '<EINV-0012874.0744@••••.vn>',
  '<WK43.0730@••••.com>', '<AN-KMHC2209@••••.vn>', '<FBL-SGNGCQ104300@••••.com>', '<AMD-6470296010@••••.tw>',
];

export interface Attachment { name: string; ext: string; size: string }
const A = (name: string, ext: string, size: string): Attachment => ({ name, ext, size });
const ATTS: Readonly<Record<number, readonly Attachment[]>> = {
  0: [A('Booking_request_W45.xlsx', 'XLS', '38 KB'), A('Packing_plan_AP2611.pdf', 'PDF', '212 KB')],
  1: [A('BKG_SGNGCQ104300.pdf', 'PDF', '96 KB')],
  2: [A('WHL_delay_notice_W028.pdf', 'PDF', '61 KB')],
  5: [A('Reefer_log_WHSU8821004.pdf', 'PDF', '140 KB')],
  6: [A('DraftBL_VN01175201.pdf', 'PDF', '180 KB')],
  7: [A('0012874.xml', 'XML', '8 KB'), A('0012874.pdf', 'PDF', '74 KB')],
};

/** Cột "why" của thư: PIC khớp theo đâu. */
const WHY: Readonly<Record<number, string>> = {
  0: 'Thư khách gửi RQ mới · Hana đọc: khách ARRIVE, hãng YML, 15x40HC, ETD tuần 45',
  1: 'Khớp booking của SE260638710 · chủ job PHUONGHT',
  2: 'Cấp tàu · PIC từng chủ job bị ảnh hưởng · NHITHT nghỉ, PHUONGHT thay',
  4: 'CS của job SE260639460 · phần VGM / SI chuyển CS',
  5: 'K4 · nhiệt độ lệch → CS của job SE260639370',
  6: 'CS của job SE260636900',
  7: 'Hoá đơn đối tác → kế toán',
  9: 'Khớp booking của SE260617730 · chủ job PHUONGHT',
};

const BODY: Readonly<Record<number, string>> = {
  1: 'Your booking SGNGCQ104300 has been confirmed.\nVessel: ONE BLUE JAY 043E · ETD 23/Oct/2026 18:00\nSI cut-off 22/Oct 16:00 · CY cut-off 23/Oct 11:00\nEquipment: 3×40HC',
};

/** Loại thư L1…L6: [tên, hạn, mô tả]. */
export const MAIL_TYPE: Readonly<Record<number, readonly [string, string, string]>> = {
  1: ['Gắn 1 job', '30′ trong giờ làm', 'Chủ job (BKG) · phần BL / SI / LOI / DEM-DET / PWC chuyển CS của job'],
  2: ['Cấp tàu / chuyến', 'cập nhật 1 giờ · báo khách trong ngày', 'Điều phối cập nhật một lần · từng chủ job báo khách của mình'],
  3: ['Tin chung hãng', 'trong ngày', 'PIC:UNASSIGNED → điều phối tóm tắt 1–2 dòng gửi nhóm BKG và Sales'],
  4: ['Chi phí phát sinh', 'trong ngày', 'CS của job làm trọn · Sales quyết định hỗ trợ khách'],
  5: ['Nhiệt độ / LOI · khẩn', 'ngay, trước cut-off', 'CS của job · BKG chỉ amend nếu cài đặt booking sai'],
  6: ['Không cần đọc', 'không', 'Rule Outlook: hoá đơn → kế toán, còn lại vào thư mục lưu'],
};
const LTYPE: Readonly<Record<string, number>> = { BOOKING: 1, SI_VGM: 1, CHUNG_TU: 1, LENH_CONT: 1, GIAO_HANG: 1, LICH_TAU: 2, NOTICE: 3, DnD_PWC: 4, URGENT_CASE: 5, THANH_TOAN: 6, KHAC: 6 };
export const mailType = (m: Mail) => (m.kind === 'none' ? 6 : (LTYPE[m.label] ?? 1));

export interface MailView {
  mail: Mail;
  msgId: string;
  body: string;
  why: string;
  atts: readonly Attachment[];
  type: number;
}

const strip = (s: string) => s.trim().replace(/^<|>$/g, '');

/** Tìm thư theo Message-ID (có / không dấu < >). Thư cũ ngoài 12 Message-ID mẫu: tạo id theo số thứ tự. */
export function findMail(messageId: string): MailView | null {
  const want = strip(messageId);
  const i = MSG_IDS.findIndex((x) => strip(x) === want);
  if (i < 0 || i >= MAILS.length) return null;
  const mail = MAILS[i]!;
  return { mail, msgId: MSG_IDS[i]!, body: BODY[i] ?? mail.body, why: WHY[i] ?? '', atts: ATTS[i] ?? [], type: mailType(mail) };
}

export const slaText = (m: Mail) => (m.slaMin < 0 ? `−${-m.slaMin}′` : `${m.slaMin}′`);
